export const FILE_TYPES = {
  image: 'image',
  document: 'document',
  video: 'video'
};

const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'webp'];
const VIDEO_EXTENSIONS = ['mp4', 'avi', 'mkv', 'mov'];
const DOCUMENT_EXTENSIONS = ['pdf', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'csv'];

export function getMessageTypeFromFileType(fileType) {
  if (!fileType) return null;

  const lowerCaseInput = fileType.toLowerCase();

  if (lowerCaseInput.startsWith('image/')) {
    return FILE_TYPES.image;
  } else if (lowerCaseInput.startsWith('application/')) {
    return FILE_TYPES.document;
  }
  return null;
}

export function getFileExtention(fileUrl) {
  if (!fileUrl) return null;

  return fileUrl.split('.').pop();
}

export function getFileName(fileUrl) {
  if (!fileUrl) return null;

  return fileUrl.split('/').pop();
}

export function fileTypeFromUrl(fileUrl) {
  if (!fileUrl) return null;

  const fileExt = getFileExtention(fileUrl);

  if (IMAGE_EXTENSIONS.includes(fileExt)) {
    return FILE_TYPES.image;
  } else if (DOCUMENT_EXTENSIONS.includes(fileExt)) {
    return FILE_TYPES.document;
  } else if (VIDEO_EXTENSIONS.includes(fileExt)) {
    return FILE_TYPES.video;
  }
}
